// extracted by mini-css-extract-plugin
export default {"rowContainer":"TodayTable_rowContainer__0y3D5","frequencyDays":"TodayTable_frequencyDays__-qWd5","frequencyPeriod":"TodayTable_frequencyPeriod__5wtOO"};